<template>
  <ul id="container__checkbox-types">
    <li
      v-for="(item, i) in newItems"
      :key="i"
      class="container__checkbox-types"
      :class="{
        'container__checkbox--checked': item.activate,
        'disable-click': disableClick,
      }"
    >
      <input
        _filter_checkbox_field
        class="products__checkbox--bg-blue mr-16 js-checkbox checkbox"
        type="checkbox"
        :name="`checkbox__products_${prefix}-${i}`"
        :id="`checkbox__products_${prefix}-${i}`"
        :checked="item.activate"
        @click="itemSelected(item)"
      />
      <label
        @click.prevent.stop="itemSelected(item)"
        :for="`checkbox__products_${prefix}-${i}`"
        class="cursor-pointer checkbox__label"
        >{{ item.desc }} {{ item.amount ? `(${item.amount})` : '' }}</label
      >
    </li>
  </ul>
</template>

<script>
import { computed, ref, toRefs } from '@vue/reactivity'
export default {
  name: 'FilterProductTypeList',
  props: {
    items: {
      type: Object,
      default: () => ({}),
    },
    prefix: {
      type: String,
      default: Math.floor(Math.random() * 1000).toString(),
    },
  },
  setup(props, context) {
    const typesOfSelectedProducts = ref([])
    const { items } = toRefs(props)
    const disableClick = ref(false)

    const newItems = computed(() => {
      const list = []
      for (const key in items.value) {
        if (items.value[key].amount !== 0) list.push(items.value[key])
      }

      if (list.length !== 0) {
        disableClick.value = false
        return list
      }
      disableClick.value = true
      return items.value
    })

    function itemSelected(selectedProduct) {
      selectedProduct.activate = !selectedProduct.activate
      if (typesOfSelectedProducts.value.includes(selectedProduct.name)) {
        typesOfSelectedProducts.value.splice(
          typesOfSelectedProducts.value.indexOf(selectedProduct.name),
          1,
        )
      } else {
        typesOfSelectedProducts.value.push(selectedProduct.name)
      }

      context.emit('productTypeHasBeeSelected', typesOfSelectedProducts)
    }

    return { itemSelected, newItems, disableClick }
  },
}
</script>
